class ScrollObserver {

    subscribers = new Map<HTMLElement, (rect: DOMRect) => void>();
    anchorRectangles = new Map<HTMLElement, DOMRect>();
    ticking = false;

    constructor() {
        window.addEventListener('scroll', this.invoke.bind(this), true);
    }

    invoke(e: Event) {
        if (!this.ticking) {
            window.requestAnimationFrame(() => {
                if (e.target instanceof HTMLElement) {
                    for (const [ element, callback ] of this.subscribers) {
                        const oldRect = this.anchorRectangles.get(element);

                        if (e.target.contains(element) && oldRect) {
                            const rect = element.getBoundingClientRect();

                            if (oldRect.left !== rect.left || oldRect.top !== rect.top) {
                                callback(rect);

                                this.anchorRectangles.set(element, rect);
                            }
                        }
                    }
                }

                this.ticking = false;
            });
            
            this.ticking = true;
        }
    }

    subscribe(element: HTMLElement, callback: (rect: DOMRect) => void) {
        const rect = element.getBoundingClientRect();
        this.subscribers.set(element, callback);
        this.anchorRectangles.set(element, rect);

    }

    unsubscribe(element: HTMLElement) {
        this.subscribers.delete(element);
    }

}

const instance = new ScrollObserver();

export default instance;
